import { Upload, Button, InputNumber } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
const element = {
  install: function(Vue) {
    Vue.use(Upload)
    Vue.use(Button)
    Vue.use(InputNumber)
  }
}
export default element
